import { IconButton, Checkbox, HStack } from '@chakra-ui/react'
import { FC, useMemo } from 'react'
import Highlighter from 'react-highlight-words'

import useParameter from '@hook/budget/use-parameters'
import useTable from '@hook/shared/use-table'

import { removeCurrencyMask } from '@helper/removeCurrentyMask'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

const TableGridParameterMarge: FC<{
  [key: string]: any
  [indexData: number]: number
}> = ({ data }) => {
  const { actions, columns, query } = useTable()
  const { handleMarge } = useParameter()

  const handleBlur = (e: string, o: number) => {
    if (!(removeCurrencyMask(e) === o)) {
      handleMarge(data['calculo-id'], removeCurrencyMask(e))
    }
  }

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left'
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])

  return (
    <tr>
      {actions && actions.length > 0 && (
        <td>
          <HStack
            spacing={2}
            w="100%"
            alignItems="center"
            justifyContent="center"
          >
            {actions.map((action, index) => {
              if (action.type === 'icon') {
                return (
                  <IconButton
                    key={`table-action-${index}`}
                    aria-label="Abrir modal"
                    icon={action.icon}
                    size="xs"
                    onClick={() => action.onSelect!(data)}
                    _hover={{
                      bg: 'yellow.200'
                    }}
                    _active={{
                      bg: 'yellow.100'
                    }}
                  />
                )
              }

              if (action.type === 'checkbox') {
                if (action.isMulti) {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="red"
                      isChecked={action.selecteds.includes(data['id-id'])}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                } else {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="yellow"
                      isChecked={action.isChecked}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      isDisabled={
                        action.selecteds !== 0
                          ? action.selecteds !== data['id-id']
                          : false
                      }
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                }
              }
            })}
          </HStack>
        </td>
      )}
      {rows.map(({ id, value, align }, key) => (
        <td
          id={id}
          key={`${id}-${key}`}
          align={align || 'left'}
          className={
            id === 'calculo-proposta' ? 'custom td-element' : 'td-element'
          }
        >
          {(() => {
            if (id === 'calculo-proposta') {
              return (
                <div
                  contentEditable
                  onBlurCapture={e =>
                    handleBlur(e.currentTarget.textContent, value)
                  }
                >
                  {query.length > 0 ? (
                    <Highlighter
                      searchWords={String(query).split(' ')}
                      textToHighlight={String(value)}
                    />
                  ) : (
                    value
                  )}
                </div>
              )
            } else {
              return (
                <div>
                  {query.length > 0 ? (
                    <Highlighter
                      searchWords={String(query).split(' ')}
                      textToHighlight={String(value)}
                    />
                  ) : (
                    value
                  )}
                </div>
              )
            }
          })()}
        </td>
      ))}
    </tr>
  )
}

export default TableGridParameterMarge
